/* eslint-disable i18next/no-literal-string */
export const TermsAndConditionsEn = () => (
  <div>
    <h2>Carson Terms of Service</h2>
    <div>
      The following terms and conditions (these “Terms of Service” or
      “Agreement”), govern a user’s (“User”, “you” or “your”) access to and use
      of this Resident Portal (the “Service”), a product offered by Carson
      Living, Inc (“Provider”, “we”, or “us”). We note that you may be, and
      these Terms of Service equally apply to you whether you are, a building, a
      management company of a building or a resident of a building.
    </div>
    <div>
      By registering to use and using the Service, you agree that you have read,
      understand and agree to be bound by these Terms of Service. Carefully
      consider the provisions of this Agreement, as they constitute binding
      legal obligations between you and Provider. We may revise and update these
      Terms of Service from time to time in our sole discretion. All changes are
      effective immediately upon posting and apply to all access and use of the
      Service, the website or any user interface. Your continued use of the
      Service, the website or any user interface following the posting of
      revised Terms of Service shall constitute your acceptance and agreement to
      be bound by the changes. Should you not wish to be bound by this
      Agreement, do not register or use the Service.
    </div>
    <div>
      <h4>1. DESCRIPTION OF THE SERVICE</h4>
      <div>
        The Service provides a web-based and mobile application allowing
        residents and property staff to communicate and manage various apartment
        dormakaba amenities and services. The Service functions as a remote
        attendant for your premises by responding to video and audio intercom
        system to allow authorized access to the premises and accept authorized
        deliveries. Although the Service may help make your premises be more
        secure, it is not a security guard and not provided or designed to
        replace or function as a security or protection service. Accordingly,
        you agree and acknowledge that Provider is not responsible for the
        security or safety of your premises, your guests and your person and
        shall not be liable to you or any other third party for any incidents,
        injuries or damages on or to your premises.
      </div>
      <div>
        You acknowledge and agree that signals which are transmitted over
        telephone lines, wire, internet connection, air waves or other modes of
        communication pass through communications networks wholly beyond the
        control of Provider and, therefore, Provider shall not be responsible
        for any failure which prevents or corrupts the transmission of
        communications associated with the Service., including, without
        limitation, SMS alerts.
      </div>
    </div>
    <div>
      <h4>2. SERVICE REGISTRATION AND ACCOUNT SECURITY</h4>
      <div>
        The Service is provided to you by Provider in accordance with the
        service agreement that you enter into with Provider, upon the terms and
        conditions of these Terms of Service and upon the express condition that
        you remain current in all payments and obligations to Provider, to the
        extent same apply to you.
      </div>
      <div>
        To register for and access the Service, you may be asked to provide
        certain registration details or other information. It is a condition of
        your use of the Service that all the information you provide on the
        registration website and user interface is correct, current, and
        complete. In the event any information you provide to us should change,
        you agree to update the information immediately. We will not be liable
        for any damage to you or to others arising out of your failure to
        provide us with complete, accurate and current information. In the event
        that any of the information provided to us is inaccurate, incomplete, or
        not current, you agree that we may, in our sole discretion, block your
        use or access of the Service until the information is corrected,
        completed or updated.
      </div>
      <div>
        You agree that all information you provide to register with this Service
        is governed by our Privacy Policy, and you consent to all actions we
        take with respect to your information consistent with our Privacy
        Policy.
      </div>
      <div>
        If you choose, or are provided with, a user name, password or any other
        piece of information as part of our security procedures, you must treat
        such information as confidential, and you must not disclose it to any
        other person or entity. You also acknowledge that your account is
        personal to you and agree not to provide any other person with access to
        this Service or portions of it using your user name, password or other
        security information. You agree to notify us immediately of any
        unauthorized access to or use of your user name or password or any other
        breach of security. You also agree to ensure that you exit from your
        account at the end of each session. You should use particular caution
        when accessing your account from a public or shared computer so that
        others are not able to view or record your password or other personal
        information. We reserve the right to disable any user name, password or
        other identifier, whether chosen by you or provided by us, at any time
        in our sole discretion for any or no reason, including if, in our
        opinion, you have violated any provision of these Terms of Service.
      </div>
    </div>
    <div>
      <h4>3. GENERAL USE OF THE SERVICE – PERMISSIONS AND RESTRICTIONS</h4>
      <div>
        Provider grants you limited, conditioned and revocable permission to
        access and use the Service, provided that you use the Service only for
        lawful purposes and in accordance with these Terms of Service. You agree
        not to use the Service:
        <ul>
          <li>
            In any way that violates any applicable federal, state, local or
            international law or regulation (including, without limitation, any
            laws regarding the export of data or software to and from the US or
            other countries).
          </li>
          <li>
            For the purpose of exploiting, harming or attempting to exploit or
            harm minors in any way by exposing them to inappropriate content,
            asking for personally identifiable information or otherwise.
          </li>
          <li>
            To send, knowingly receive, upload, download, use or re-use any
            material which does not comply with the Content Standards set out in
            these Terms of Service.
          </li>
          <li>
            To transmit, or procure the sending of, any advertising or
            promotional material [without our prior written consent], including
            any “junk mail”, “chain letter” or “spam” or any other similar
            solicitation.
          </li>
          <li>
            To impersonate or attempt to impersonate Provider, a Provider
            employee, another user, or any other person or entity (including,
            without limitation, by using e-mail addresses or user names
            associated with any of the foregoing).
          </li>
          <li>
            To engage in any other conduct that restricts or inhibits anyone’s
            use or enjoyment of the Service, or which, as determined by us, may
            harm Provider or users of the Service or expose them to liability.
          </li>
          <li>
            You understand that, provider can add and remove this service, in
            order to facilitate your occupancy and enjoyment of the premises.
          </li>
          <li>
            You understand that this service might be provided on a temporary
            basis only, and that such service is not intended to nor shall it be
            provided on a permanent basis. You understand that the temporary
            service is not and shall not be considered as “required service“
            under the Rent Stabilization Law and/or Code.
          </li>
          <li>
            You further acknowledges that the removal of such temporary service
            does not allow you to withhold or deduct rent or to seek any offset,
            reduction, concession or abatement based on diminution of services
            or breach of the Warranty of Habitability due to any conditions
            arising from removal of the service.
          </li>
        </ul>
      </div>
      <div>
        Additionally, you agree not to:
        <ul>
          <li>
            Use the Service in any manner that could disable, overburden,
            damage, or impair the site or interfere with any other party’s use
            of the Service, including their ability to engage in real time
            activities through the Service.
          </li>
          <li>
            Use any robot, spider or other automatic device, process or means to
            access the Service for any purpose, including monitoring or copying
            any of the material on the Service.
          </li>
          <li>
            Use any manual process to monitor or copy any of the material on the
            Service or for any other unauthorized purpose without our prior
            written consent.
          </li>
          <li>
            Use any device, software or routine that interferes with the proper
            working of the Service.
          </li>
          <li>
            Introduce any viruses, trojan horses, worms, logic bombs or other
            material which is malicious or technologically harmful.
          </li>
          <li>
            Attempt to gain unauthorized access to, interfere with, damage or
            disrupt any parts of the Service, the server on which the Service is
            stored, or any server, computer or database connected to the
            Service.
          </li>
          <li>
            Attack the Service via a denial-of-service attack or a distributed
            denial-of-service attack.
          </li>
          <li>
            Otherwise attempt to interfere with the proper working of the
            Service.
          </li>
        </ul>
      </div>
    </div>
    <div>
      <h4>4. SMS TEXT ALERTS AND NOTIFICATIONS</h4>
      <div>
        We offer you the ability to enroll your mobile phone in our Short
        Messaging Service (“SMS”) text message alert system (the “SMS System”)
        for purposes of receiving Service notifications and emergency alerts.
        Your enrollment or use of the SMS System constitutes your agreement to
        the following terms and conditions:
      </div>
      <div>
        By providing your mobile phone number(s) to Provider as part of your
        registration for the SMS System, you provide us with your express
        consent to receive text message alerts at that number and:
      </div>
      <div>
        i. Acknowledge and represent to us that you are the authorized user of
        the mobile phone(s) that you link to our text message service or have
        been granted permission by the authorized user of the mobile phone(s) to
        enroll such mobile phone(s) in the service;
      </div>
      <div>
        ii. You grant Provider express permission to send text messages to that
        (those) mobile phone(s) through your wireless phone carrier unless and
        until such permission is revoked in accordance with these terms and
        conditions;
      </div>
      <div>
        iii. Your receipt of SMS messages from Provider (“SMS alerts”) is NOT a
        violation of state or federal rules including, but not limited to, the
        Telephone Consumer Protection Act (TCPA) or Controlling the Assault of
        Non-Solicited Pornography and Marketing (CAN-SPAM) Act;
      </div>
      <div>
        iv. You understand that your wireless carrier may charge you additional
        message and data fees for receipt of our text messages; and
      </div>
      <div>
        v. By granting such permission to Provider you are hereby requesting to
        receive such messages in spite of the fact that your number may
        otherwise be on the federal, or a state’s, do not call list and you
        agree, to the maximum extent permitted by law, that such text messages
        shall not be in violation of such do not call list(s).
      </div>
      <div>
        Prior to completing your enrollment in the Service, we will send a text
        message to your designated mobile number. To complete enrollment, you
        must confirm receipt of the text message from your device by following
        the instructions in that text message. You may cancel your enrollment in
        the SMS System at any time by logging into the Service and removing your
        mobile number(s) from the SMS System registration. You may also cancel
        your enrollment by sending an SMS System opt-out request email to&nbsp;
        <a href="mailto:hello@carson.live">hello@carson.live</a>
      </div>
      <div>
        Provider SMS alerts are available to Users based in the United States.
        User understands and acknowledges that SMS alerts are not intended to be
        accessed from outside of the United States. In addition, because
        Provider does not operate or control the wireless networks used to
        access the SMS alerts, we cannot guarantee the privacy or security of
        wireless data transmissions. Please check with your wireless service
        provider for information about its privacy and security practices.
        PROVIDER IS NOT RESPONSIBLE FOR INCOMPLETE, LOST, LATE, OR MISDIRECTED
        MESSAGES, INCLUDING (BUT NOT LIMITED TO) UNDELIVERED MESSAGES RESULTING
        FROM ANY FORM OF FILTERING BY YOUR MOBILE CARRIER OR SERVICE PROVIDER.
        PROVIDER ALSO MAKES NO REPRESENTATIONS OR WARRANTIES WHATSOEVER
        REGARDING SMS ALERTS. THE SMS SYSTEM IS PROVIDED ON AN “AS IS” AND “AS
        AVAILABLE” BASIS. PROVIDER AND ITS SUBSIDIARIES, AFFILIATES, OFFICERS,
        AGENTS, EMPLOYEES, PARTNERS, AND LICENSORS EXPRESSLY DISCLAIM ALL
        WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT
        LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
        PARTICULAR PURPOSE AND NON-INFRINGEMENT. PROVIDER, ITS SUBSIDIARIES,
        AFFILIATES, OFFICERS, AGENTS, EMPLOYEES, PARTNERS, AND LICENSORS MAKE NO
        WARRANTY THAT (A) THE SMS SYSTEM WILL MEET YOUR REQUIREMENTS; (B) THE
        SMS SYSTEM WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE; OR (C)
        THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SMS SYSTEM WILL BE
        ACCURATE OR RELIABLE.
      </div>
    </div>
    <div>
      <h4>5. SITE CONTENT AND INTELLECTUAL PROPERTY RIGHTS</h4>
      <div>
        The Service and its entire contents, features and functionality
        (including but not limited to all information, software, text, displays,
        images, video and audio, and the design, selection and arrangement
        thereof), are owned by Provider, its licensors or other providers of
        such material and are protected by United States and international
        copyright, trademark, patent, trade secret and other intellectual
        property or proprietary rights laws.
      </div>
      <div>
        These Terms of Service permit you to use the Service for your personal,
        non-commercial use only. You must not reproduce, distribute, modify,
        create derivative works of, publicly display, publicly perform,
        republish, download, store or transmit any of the material on our
        Service, except as follows:
        <ul>
          <li>
            Your computer may temporarily store copies of such materials in RAM
            incidental to your accessing and viewing those materials.
          </li>
          <li>
            You may store files that are automatically cached by your Web
            browser for display enhancement purposes.
          </li>
          <li>
            You may print or download one copy of a reasonable number of pages
            of the Service for your own personal, non-commercial use and not for
            further reproduction, publication or distribution.
          </li>
          <li>
            If we provide desktop, mobile or other applications for download,
            you may download a single copy to your computer or mobile device
            solely for your own personal, non-commercial use, provided you agree
            to be bound by our end user license agreement for such applications.
          </li>
          <li>
            If we provide social media features with certain content, you may
            take such actions as are enabled by such features.
          </li>
        </ul>
      </div>
      <div>
        You must not:
        <ul>
          <li>Modify copies of any materials from this site.</li>
          <li>
            Use any illustrations, photographs, video or audio sequences or any
            graphics separately from the accompanying text.
          </li>
          <li>
            Delete or alter any copyright, trademark or other proprietary rights
            notices from copies of materials from this site.
          </li>
        </ul>
      </div>
      <div>
        You must not access or use for any commercial purposes any part of the
        Service or any services or materials available through the Service. If
        you print, copy, modify, download or otherwise use or provide any other
        person with access to any part of the Service in breach of the Terms of
        Service, your right to use the Service will cease immediately and you
        must, at our option, return or destroy any copies of the materials you
        have made. No right, title or interest in or to the Service or any
        content on the Service is transferred to you, and all rights not
        expressly granted are reserved by the Company. Any use of the Service
        not expressly permitted herein is a breach of these Terms of Service and
        may violate copyright, trademark and other laws.
      </div>
    </div>
    <div>
      <h4>6. TRADEMARKS</h4>
      <div>
        The Carson name and logo, and all related names, logos, product and
        service names, designs and slogans are trademarks of Provider or its
        affiliates or licensors. You must not use such marks without the prior
        written permission of Provider. All other names, logos, product and
        service names, designs and slogans on this Website are the trademarks of
        their respective owners.
      </div>
    </div>
    <div>
      <h4>7. USER CONTRIBUTIONS</h4>
      <div>
        The Service may contain message boards, chat rooms, personal profiles,
        forums, bulletin boards, social media integration, and other interactive
        features (collectively, “Interactive Services“) that allow users to
        post, submit, publish, display or transmit to other users or other
        persons (hereinafter, “post“) content or materials (collectively, “User
        Contributions“) on or through the Service.
      </div>
      <div>
        All User Contributions must comply with the Content Standards set out in
        these Terms of Service.
      </div>
      <div>
        Any User Contribution you post to the Service will be considered
        non-confidential and nonproprietary. By providing any User Contribution
        on the Service, you grant us and our affiliates and service providers,
        and each of their and our respective licensees, successors and assigns
        the right to use, reproduce, modify, perform, display, distribute and
        otherwise disclose to third parties any such material for any purpose.
      </div>
      <div>
        You represent and warrant that:
        <ul>
          <li>
            You own or control all rights in and to the User Contributions and
            have the right to grant the license granted above to us and our
            affiliates and service providers, and each of their and our
            respective licensees, successors and assigns.
          </li>
          <li>
            All of your User Contributions do and will comply with these Terms
            of Service.
          </li>
        </ul>
      </div>
      <div>
        You understand and acknowledge that you are responsible for any User
        Contributions you submit or contribute, and you, not Provider, have
        fully responsibility for such content, including its legality,
        reliability, accuracy and appropriateness.
      </div>
      <div>
        We are not responsible, or liable to any third party, for the content or
        accuracy of any User Contributions posted by you or any other user of
        the Service.
      </div>
    </div>
    <div>
      <h4>8. CONTENT STANDARDS</h4>
      <div>
        These content standards apply to any and all User Contributions and use
        of the Service. User Contributions must in their entirety comply with
        all applicable federal, state, local and international laws and
        regulations. Without limiting the foregoing, User Contributions must
        not:
        <ul>
          <li>
            Contain any material which is defamatory, obscene, indecent,
            abusive, offensive, harassing, violent, hateful, inflammatory or
            otherwise objectionable.
          </li>
          <li>
            Promote sexually explicit or pornographic material, violence, or
            discrimination based on race, sex, religion, nationality,
            disability, sexual orientation or age.
          </li>
          <li>
            Infringe any patent, trademark, trade secret, copyright or other
            intellectual property or other rights of any other person.
          </li>
          <li>
            Violate the legal rights (including the rights of publicity and
            privacy) of others or contain any material that could give rise to
            any civil or criminal liability under applicable laws or regulations
            or that otherwise may be in conflict with these Terms of Use and our
            Privacy Policy.
          </li>
          <li>Be likely to deceive any person.</li>
          <li>
            Promote any illegal activity, or advocate, promote or assist any
            unlawful act.
          </li>
          <li>
            Cause annoyance, inconvenience or needless anxiety or be likely to
            upset, embarrass, alarm or annoy any other person.
          </li>
          <li>
            Impersonate any person, or misrepresent your identity or affiliation
            with any person or organization.
          </li>
          <li>
            Involve commercial activities or sales, such as contests,
            sweepstakes and other sales promotions, barter or advertising.
          </li>
          <li>
            Give the impression that they emanate from or are endorsed by us or
            any other person or entity, if this is not the case.
          </li>
        </ul>
      </div>
    </div>
    <div>
      <h4>9. MONITORING AND ENFORCEMENT; TERMINATION OF SERVICE</h4>
      <div>
        We have the right to:
        <ul>
          <li>
            Remove or refuse to post any User Contributions for any or no reason
            in our sole discretion.
          </li>
          <li>
            Take any action with respect to any User Contribution that we deem
            necessary or appropriate in our sole discretion, including if we
            believe that such User Contribution violates the Terms of Service,
            including the Content Standards, infringes any intellectual property
            right or other right of any person or entity, threatens the personal
            safety of users of the Service or the public or could create
            liability for Provider.
          </li>
          <li>
            Disclose your identity or other information about you to any third
            party who claims that material posted by you violates their rights,
            including their intellectual property rights or their right to
            privacy.
          </li>
          <li>
            Take appropriate legal action, including without limitation,
            referral to law enforcement, for any illegal or unauthorized use of
            the Service.
          </li>
          <li>
            Terminate or suspend your access to all or part of the Service for
            any or no reason, including without limitation, any violation of
            these Terms of Service.
          </li>
        </ul>
      </div>
      <div>
        Without limiting the foregoing, we have the right to fully cooperate
        with any law enforcement authorities or court order requesting or
        directing us to disclose the identity or other information of anyone
        posting any materials on or through the Service. YOU WAIVE AND HOLD
        HARMLESS THE COMPANY AND ITS AFFILIATES, LICENSEES AND SERVICE PROVIDERS
        FROM ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY ANY OF THE FOREGOING
        PARTIES DURING OR AS A RESULT OF ITS INVESTIGATIONS AND FROM ANY ACTIONS
        TAKEN AS A CONSEQUENCE OF INVESTIGATIONS BY EITHER SUCH PARTIES OR LAW
        ENFORCEMENT AUTHORITIES.
      </div>
      <div>
        However, we do not undertake to review material before it is posted on
        the Service, and cannot ensure prompt removal of objectionable material
        after it has been posted. Accordingly, we assume no liability for any
        action or inaction regarding transmissions, communications or content
        provided by any user or third party. We have no liability or
        responsibility to anyone for performance or nonperformance of the
        activities described in this section.
      </div>
    </div>
    <div>
      <h4>10. COPYRIGHT INFRINGEMENT</h4>
      <div>
        It is the policy of Carson Living, Inc to respond to claims of
        intellectual property infringement. We will promptly investigate notices
        of alleged infringement and will take appropriate actions required under
        the Digital Millennium Copyright Act, Title 17, United States Code,
        Section 512(c)(2) (“DMCA”) and other applicable intellectual property
        laws.
      </div>
      <div>
        Pursuant to the DMCA, notifications of claimed copyright infringement
        should be sent to a Service Provider’s Designated Agent. Notification
        must be submitted to the following Designated Agent for Carson Living,
        Inc:
        <br />
        Carson Living, Inc.
        <br />
        85 Fifth Ave, 4th Floor
        <br />
        New York, NY 10003
        <br />
        USA
        <br />
        <a href="mailto:hello@carson.live">hello@carson.live</a>
      </div>
      <div>
        To be effective, the notification must be a written communication that
        includes the following:
        <ul>
          <li>
            A physical or electronic signature of a person authorized to act on
            behalf of the owner of the infringed copyright;
          </li>
          <li>
            Identification of the copyrighted work claimed to have been
            infringed, or, if multiple copyrighted works at a single online site
            are covered by a single notification, a representative list of such
            works at that site;
          </li>
          <li>
            Identification of the material that is claimed to be infringing or
            to be the subject of infringing activity and that is to be removed
            or access to which is to be disabled, and information reasonably
            sufficient to permit the service provider to locate the material;
          </li>
          <li>
            Information reasonably sufficient to permit the service provider to
            contact the complaining party, such as an address, telephone number
            and, if available, an electronic mail address at which the
            complaining party may be contacted;
          </li>
          <li>
            A statement that the complaining party has a good-faith belief that
            use of the material in the manner complained of is not authorized by
            the copyright owner, its agent or the law; and
          </li>
          <li>
            A statement that the information in the notification is accurate
            and, under penalty of perjury, that the complaining party is
            authorized to act on behalf of the copyright owner.
          </li>
        </ul>
      </div>
    </div>
    <div>
      <h4>11. LINKS TO THIRD PARTIES</h4>
      <div>
        If the Service contains links to other sites and resources provided by
        third parties, these links are provided for your convenience only. This
        includes links contained in advertisements, including banner
        advertisements and sponsored links. We have no control over the contents
        of those sites or resources, and accept no responsibility for them or
        for any loss or damage that may arise from your use of them. If you
        decide to access any of the third party websites or services linked to
        this Service, you do so entirely at your own risk and subject to the
        terms and conditions of use for such websites.
      </div>
    </div>
    <div>
      <h4>12. MONITORING PLATFORM ACCESS</h4>
      <div>
        To the extent you have been granted direct access to Provider’s
        monitoring platform, allowing you to monitor and/or control aspects of
        the Service (the ‘Monitoring Platform’) then you agree that your access
        to the Monitoring Platform is conditional upon the following
        undertakings: You agree and undertake that the format, content, design
        and services of and contained within the Monitoring Platform (the
        “Monitoring Platform IP”) is the proprietary and confidential
        information of the Provider and you shall not: (i) use the Monitoring
        Platform IP or any portion of it for any purpose other than as part of
        your use of the Service as approved by Provider; (ii) disclose the
        Monitoring Platform IP or any part of it to any third party, without
        Provider’s prior written consent; (iii) directly or indirectly copy or
        otherwise reproduce all or any portion of the Monitoring Platform IP;
        (iv) seek to directly or indirectly develop a product with features
        similar to the Monitoring Platform or the Service or which otherwise
        directly or indirectly competes with the Monitoring Platform or the
        Service or any part of it, through the term of your agreement with
        Provider and for a period of two years thereafter; (v) circumvent or
        attempt to circumvent the undertakings contained herein. You acknowledge
        that Provider will be irreparably harmed if your undertakings herein are
        not specifically enforced and that Provider would not have an adequate
        remedy at law in the event of an actual or threatened violation by you
        of these obligations. Therefore, in addition to all other remedies it
        may have, Provider shall be entitled to an injunction or any appropriate
        decree of specific performance for any actual or threatened violations
        or breaches by the you without having to show actual damages.
      </div>
    </div>
    <div>
      <h4>13. DISCLAIMER OF WARRANTIES</h4>
      <div>
        YOUR USE OF THE SERVICE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED
        THROUGH THE SERVICE IS AT YOUR OWN RISK. THE SERVICE, ITS CONTENT AND
        ANY SERVICES OR ITEMS OBTAINED THROUGH THE SERVICE ARE PROVIDED ON AN
        “AS IS” AND “AS AVAILABLE” BASIS, WITHOUT ANY WARRANTIES OF ANY KIND,
        EITHER EXPRESS OR IMPLIED. NEITHER THE COMPANY NOR ANY PERSON ASSOCIATED
        WITH THE COMPANY MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO
        THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY OR
        AVAILABILITY OF THE SERVICE. WITHOUT LIMITING THE FOREGOING, NEITHER THE
        COMPANY NOR ANYONE ASSOCIATED WITH THE COMPANY REPRESENTS OR WARRANTS
        THAT THE SERVICE, ITS CONTENT OR ANY SERVICES OR ITEMS OBTAINED THROUGH
        THE SERVICE WILL BE ACCURATE, RELIABLE, ERROR-FREE OR UNINTERRUPTED,
        THAT DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES
        IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE
        SERVICE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SERVICE WILL
        OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
      </div>
      <div>
        THE COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS
        OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY
        WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR
        PARTICULAR PURPOSE.
      </div>
      <div>
        THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR
        LIMITED UNDER APPLICABLE LAW.
      </div>
    </div>
    <div>
      <h4>14. LIMITATION ON LIABILITY</h4>
      <div>
        IN NO EVENT WILL PROVIDER, ITS AFFILIATES OR THEIR LICENSORS, SERVICE
        PROVIDERS, EMPLOYEES, AGENTS, OFFICERS OR DIRECTORS BE LIABLE FOR
        DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN
        CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE SERVICE, ANY SERVICES
        LINKED TO IT, ANY CONTENT ON THE SERVICE OR ANY SERVICES OR ITEMS
        OBTAINED THROUGH THE SERVICE, INCLUDING ANY DIRECT, INDIRECT, SPECIAL,
        INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED
        TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF
        REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS
        OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT
        (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF
        FORESEEABLE.
      </div>
      <div>
        THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR
        LIMITED UNDER APPLICABLE LAW.
      </div>
      <div>
        EXCEPT FOR WILLFUL OR MALICIOUS TORTIOUS OR CRIMINAL ACTS BY PROVIDER,
        YOU AGREE THAT IN NO EVENT WILL THE COLLECTIVE LIABILITY OF PROVIDER
        (AND ITS AFFILIATES, PARENTS, SUBSIDIARIES, OFFICERS, EMPLOYEES,
        DIRECTORS, AGENTS AND SUPPLIERS) EXCEED THE GREATER OF $2,500 (TWO
        THOUSAND FIVE HUNDRED DOLLARS) OR THE AMOUNT OF MONIES YOU HAVE PAID TO
        PROVIDER DURING THE TWELVE MONTH PERIOD IMMEDIATELY PRIOR TO THE ACT OUT
        OF WHICH LIABILITY AROSE.
      </div>
    </div>
    <div>
      <h4>15. INDEMNIFICATION</h4>
      <div>
        You agree to defend, indemnify and hold harmless Provider, its
        affiliates, licensors and service providers, and its and their
        respective officers, directors, employees, contractors, agents,
        licensors, suppliers, successors and assigns from and against any
        claims, liabilities, damages, judgments, awards, losses, costs, expenses
        or fees (including reasonable attorneys’ fees) arising out of or
        relating to your violation of these Terms of Service or your use of the
        Service, including, but not limited to, your User Contributions, any use
        of the Service’s content, services and products other than as expressly
        authorized in these Terms of Service or your use of any information
        obtained from the Service.
      </div>
    </div>
    <div>
      <h4>16. GOVERNING LAW AND JURISDICTION</h4>
      <div>
        All matters relating to the Service and these Terms of Service and any
        dispute or claim arising therefrom or related thereto (in each case,
        including non-contractual disputes or claims), shall be governed by and
        construed in accordance with the internal laws of the State of New York
        without giving effect to any choice or conflict of law provision or rule
        (whether of the State of New York or any other jurisdiction).
      </div>
      <div>
        Any legal suit, action or proceeding arising out of, or related to,
        these Terms of Service or the Service shall be instituted exclusively in
        the courts of the State of New York in each case located in the City of
        New York and County of New York although we retain the right to bring
        any suit, action or proceeding against you for breach of these Terms of
        Service in your country of residence or any other relevant country. You
        waive any and all objections to the exercise of jurisdiction over you by
        such courts and to venue in such courts.
      </div>
    </div>
    <div>
      <h4>17. LIMITATION ON TIME TO FILE CLAIMS</h4>
      <div>
        ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING TO
        THESE TERMS OF SERVICE OR THE SERVICE MUST BE COMMENCED WITHIN ONE (1)
        YEAR AFTER THE CAUSE OF ACTION ACCRUES, OTHERWISE, SUCH CAUSE OF ACTION
        OR CLAIM IS PERMANENTLY BARRED.
      </div>
    </div>
    <div>
      <h4>18. WAIVER AND SEVERABILITY</h4>
      <div>
        No waiver of by Provider of any term or condition set forth in these
        Terms of Service shall be deemed a further or continuing waiver of such
        term or condition or a waiver of any other term or condition, and any
        failure of Provider to assert a right or provision under these Terms of
        Service shall not constitute a waiver of such right or provision.
      </div>
      <div>
        If any provision of these Terms of Service is held by a court or other
        tribunal of competent jurisdiction to be invalid, illegal or
        unenforceable for any reason, such provision shall be eliminated or
        limited to the minimum extent such that the remaining provisions of the
        Terms of Service will continue in full force and effect.
      </div>
    </div>
    <div>
      <h4>19. ENTIRE AGREEMENT</h4>
      <div>
        The Terms of Service and our Privacy Policy constitute the sole and
        entire agreement between you and Provider with respect to the Service
        and supersede all prior and contemporaneous understandings, agreements,
        representations and warranties, both written and oral, with respect to
        the Service.
      </div>
    </div>
  </div>
);
